/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Rename_TitleInputs */

const vi_irrigation_rename_title = /** @type {(inputs: Irrigation_Rename_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đổi tên trạm bơm`)
};

/**

* @param {Irrigation_Rename_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_rename_title = /** @type {((inputs?: Irrigation_Rename_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Rename_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_rename_title(inputs)
});